import React from 'react';
import { useSelector } from 'react-redux';

import BlogItem from './BlogItem';

import './style.css';

const Blog = () => {
   const blog = useSelector(state => state.blog.blog);
   return (
      <div className='blog--block _container' id='blog'>
         <div className="project_content--text">
            <div className="project--front_title">Recent Blogs</div>
            <div className="project--subb">Get updates about our latest trends and techniques used in interior design project works.</div>
         </div>
         <div className="blog__item--container">
            {blog.map(el => (
               <BlogItem key={el.id} item={el} />
            ))}
         </div>
      </div>
   )
}

export default Blog;
